import { Button } from '../ui/button';
import { ChevronDown, ChevronRight, Clock } from 'lucide-react';

export default function CollapsibleAssignmentHeader({
  title,
  icon: Icon,
  expanded,
  onToggle,
  count,
  totalHours,
  totalOvertime = 0,
  perName,
  testid,
}) {
  return (
    <div>
      <button
        type="button"
        onClick={onToggle}
        className="w-full flex flex-wrap items-center justify-between gap-2 text-left group"
        data-testid={`${testid}-toggle`}
        aria-expanded={expanded}
      >
        <h4 className="text-base md:text-lg font-bold text-slate-900 flex items-center gap-2 min-w-0">
          <Icon size={20} className="shrink-0" />
          {title}
        </h4>
        <div className="flex items-center gap-3">
          <span className="text-sm text-slate-600">
            <span data-testid={`${testid}-count`} className="font-semibold">
              {count}
            </span>{' '}
            {count === 1 ? 'assignment' : 'assignments'}
            {' · '}
            <span data-testid={`${testid}-total-hours`} className="font-semibold">
              {totalHours} hrs
            </span>
            {totalOvertime > 0 && <span className="ml-2 font-semibold text-amber-700" data-testid={`${testid}-total-overtime`}>+{totalOvertime} OT</span>}
          </span>
          {expanded ? (
            <ChevronDown size={18} className="text-slate-500 group-hover:text-slate-900 transition" />
          ) : (
            <ChevronRight size={18} className="text-slate-500 group-hover:text-slate-900 transition" />
          )}
        </div>
      </button>

      {expanded && perName.length > 0 && (
        <div
          className="mt-3 mb-4 flex flex-wrap gap-2"
          data-testid={`${testid}-totals`}
        >
          {perName.map((row) => (
            <span
              key={row.name}
              className="inline-flex items-center gap-1 px-3 py-1 bg-slate-100 border border-slate-200 rounded-full text-xs font-medium text-slate-700"
              data-testid={`${testid}-total-${row.name}`}
            >
              <span>{row.name}</span>
              <span className="text-slate-400">·</span>
              <span className="flex items-center gap-1 text-slate-600">
                <Clock size={11} />
                {row.hours} hrs
              </span>
              {row.overtime > 0 && (
                <>
                  <span className="text-slate-400">·</span>
                  <span className="text-amber-700 font-semibold">+{row.overtime} OT</span>
                </>
              )}
            </span>
          ))}
        </div>
      )}
    </div>
  );
}
